import { autoLogin, getInfo, login, logout } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

// 重置路由
const resetRouter = () => {}

const state = {
  token: getToken(),
  name: '', // 用户姓名
  mname: '', // 商户名
  userInfo: null,
  isLogin: false
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_MERCHANT_NAME: (state, mname) => {
    state.mname = mname
  },
  SET_USERINFO(state, userInfo) {
    state.userInfo = userInfo
    state.isLogin = !!userInfo

    if (userInfo) {
      state.name = userInfo.username || userInfo.name || ''
    }
  },
  CLEAR_USERINFO(state) {
    state.userInfo = null
    state.isLogin = false
    state.name = ''
  }
}

const actions = {
  // 用户登录
  login({ commit, dispatch }, userInfo) {
    const { username, password, code } = userInfo
    return new Promise((resolve, reject) => {
      login(username.trim(), password, code)
        .then(response => {
          sessionStorage.setItem('user_id', response.resultInfo)
          const { data } = response
          commit('SET_TOKEN', '123456')
          setToken('123456')
          // 登录成功后，立即调用getInfo获取用户信息
          return dispatch('getInfo')
        })
        .then(() => {
          resolve()
        })
        .catch(error => reject(error))
    })
  },

  autoLogin({ commit }, userInfo) {
    // const { username, keyword } = userInfo
    return new Promise((resolve, reject) => {
      autoLogin(userInfo)
        .then(response => {
          const { data } = response
          commit('SET_TOKEN', '123456') // 存到vuex的token
          setToken('123456') // 存到cookie 的 token
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取用户信息
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(response => {
          if (response.resultCode != 1) {
            reject('验证失败，请重新登录。')
          } else {
            const userInfo = response.resultInfo.info
            const name = response.resultInfo.info.username // 获取到账户名称
            const mname = response.resultInfo.mname
            commit('SET_USERINFO', userInfo) // 设置用户数据
            commit('SET_NAME', name) //设置用户名字
            commit('SET_MERCHANT_NAME', mname) // 商户名
            resolve(response.resultInfo)
          }
        })
        .catch(error => {
          commit('CLEAR_USERINFO')
          reject(error)
        })
    })
  },

  // 退出登录
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          commit('SET_TOKEN', '')
          commit('CLEAR_USERINFO')
          removeToken()
          resetRouter()
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 清除token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('CLEAR_USERINFO')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
